import mdxComponents from '../components/mdx-components'

export default mdxComponents
